import React, { useMemo, useRef } from 'react';
import { divIcon } from 'leaflet';
import { Marker as LeafletMarker } from 'react-leaflet';
import { renderToStaticMarkup } from 'react-dom/server';
import { ReactBaseProvider, Icon, useTheme, useIconResolver, invokeEventHandler } from '@wemogy/reactbase';
var Marker = function (_a) {
    var position = _a.position, icon = _a.icon, iconVariation = _a.iconVariation, onPositionChanged = _a.onPositionChanged;
    var theme = useTheme();
    var iconResolver = useIconResolver();
    var markerRef = useRef(null);
    var eventHandlers = useMemo(function () { return ({
        dragend: function () {
            var marker = markerRef.current;
            if (marker != null) {
                var newPosition = marker.getLatLng();
                invokeEventHandler(onPositionChanged, {
                    latitude: newPosition.lat,
                    longitude: newPosition.lng
                });
            }
        },
    }); }, [markerRef]);
    var customMarkerIcon = useMemo(function () {
        // ToDo: get the icon size from the iconVariation
        var iconSize = 32;
        return divIcon({
            html: renderToStaticMarkup(React.createElement(ReactBaseProvider, { theme: theme, iconResolver: iconResolver },
                React.createElement(Icon, { icon: icon, variationKey: iconVariation }))),
            // null will make the icon div grow with the content
            iconSize: [iconSize, iconSize],
            iconAnchor: [iconSize / 2, iconSize]
        });
    }, [icon, iconVariation]);
    return (React.createElement(LeafletMarker, { draggable: onPositionChanged !== undefined, eventHandlers: eventHandlers, position: {
            lat: position.latitude,
            lng: position.longitude
        }, icon: customMarkerIcon, ref: markerRef }));
};
export default Marker;
//# sourceMappingURL=Marker.js.map